'use client';

import { forwardRef } from 'react';
import type { LucideProps } from 'lucide-react';

/**
 * Lucide `messages-circle` inlined — not exported in lucide-react@1.39.0 (current
 * yarn.lock). Paths from https://lucide.dev/icons/messages-circle
 */
export const MessagesCircleGlyph = forwardRef<SVGSVGElement, LucideProps>(
  function MessagesCircleGlyph(
    { color = 'currentColor', size = 24, strokeWidth = 2, children, ...props },
    ref,
  ) {
    return (
      <svg
        ref={ref}
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
        {...props}
      >
        <path
          d="M19.95 10.05a7 7 0 011.412 7.872 1 1 0 00-.058.787l.675 2.089a1 1 0 01-1.236 1.168l-2.155-.631a1 1 0 00-.745.06 7 7 0 01-7.793-1.445"
        />
        <path
          d="M2.696 12.708a1 1 0 00-.058-.785 7 7 0 113.518 3.473 1 1 0 00-.744-.061l-2.155.63a1 1 0 01-1.236-1.167z"
        />
        {children}
      </svg>
    );
  },
);

MessagesCircleGlyph.displayName = 'MessagesCircle';
